import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsInterventionsSpeedPerOperationTrailerReportComponent } from './fields-interventions-speed-per-operation-trailer-report.component';
import {DxChartModule, DxPivotGridModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldsInterventionsSpeedPerOperationTrailerReportComponent],
  imports: [
    CommonModule,
    DxPivotGridModule,
    DxChartModule
  ],
  exports: [FieldsInterventionsSpeedPerOperationTrailerReportComponent]
})
export class FieldsInterventionsSpeedPerOperationTrailerReportModule { }
